/**
 * Lógica del nivel de riesgo según matriz Impacto × Vulnerabilidad × Probabilidad.
 * Rangos de calificación según tabla de criterios:
 * - 1 a 10: Riesgo Bajo (RB)
 * - 11 a 25: Riesgo Medio (RM)
 * - 26 a 50: Riesgo Alto (RA)
 * - 51 a 125: Riesgo Superior (RS)
 */

/**
 * Calcula el puntaje numérico del riesgo.
 * @param {number} impact - Valor 1-5 (Insignificante a Enorme)
 * @param {number} vulnerability - Valor 1, 3 o 5 (Baja, Media, Alta)
 * @param {number} probability - Valor 1-5 (Raro a Casi seguro)
 * @returns {number} Puntaje = impact * vulnerability * probability (rango 1-125)
 */
export const getRiskScore = (impact, vulnerability, probability) => {
  const i = parseInt(impact, 10) || 0;
  const v = parseInt(vulnerability, 10) || 0;
  const p = parseInt(probability, 10) || 0;
  if (!i || !v || !p) return 0;
  return i * v * p;
};

/** Rangos de la tabla de calificación del riesgo */
const RISK_RANGES = [
  { min: 1, max: 10, riskLeveltype: 1, code: "RB", class: "low-level", textClass: "low-level-text", text: "Nivel Bajo" },
  { min: 11, max: 25, riskLeveltype: 2, code: "RM", class: "medium-level", textClass: "medium-level-text", text: "Nivel Medio" },
  { min: 26, max: 50, riskLeveltype: 3, code: "RA", class: "high-level", textClass: "high-level-text", text: "Nivel Alto" },
  { min: 51, max: 125, riskLeveltype: 4, code: "RS", class: "superior-level", textClass: "superior-level-text", text: "Nivel Superior" }
];

const DEFAULT_LEVEL = {
  riskLeveltype: 0,
  class: "default-level",
  textClass: "default-level-text",
  text: "Sin Nivel"
};

/**
 * Obtiene la calificación del riesgo a partir del puntaje numérico.
 * @param {number} score - Puntaje calculado (impact × vulnerability × probability)
 * @returns {{ riskLeveltype: number, code: string|null, class: string, textClass: string, text: string }}
 */
export const getRiskLevelFromScore = (score) => {
  const value = parseInt(score, 10);
  if (!value || value < 1) return DEFAULT_LEVEL;
  const found = RISK_RANGES.find((r) => value >= r.min && value <= r.max);
  return found || DEFAULT_LEVEL;
};
